import React, { useEffect, useState } from "react";
import { Info, BookOpen, Gamepad2, ScrollText, Phone, FileText, ChevronRight, ImageIcon } from "lucide-react";
import { api } from "../../lib/api";
import { C } from "./ui";
import { Sheet, Empty } from "./Sheet";

// Ikon ubin dipilih dari judul halaman (ikon khusus menyusul bila admin bisa memilih)
function ikonUntuk(title = "") {
  const t = title.toLowerCase();
  if (t.includes("tentang")) return BookOpen;
  if (t.includes("main") || t.includes("cara")) return Gamepad2;
  if (t.includes("aturan")) return ScrollText;
  if (t.includes("kontak") || t.includes("hubungi")) return Phone;
  return FileText;
}

// Sheet Info: ubin 2 kolom (ikon/sampul + judul + cuplikan) → halaman dengan sampul (jika ada) dan isi berparagraf
export function InfoSheet({ onClose }) {
  const [pages, setPages] = useState(null);
  const [sel, setSel] = useState(null);
  useEffect(() => { api.publicInfo().then(d => setPages(d.pages || [])).catch(() => setPages([])); }, []);

  if (sel) {
    const paras = String(sel.content || "").split(/\n{2,}/);
    return (
      <Sheet testid="info-page" title={sel.title} onBack={() => setSel(null)} onClose={onClose}>
        {sel.cover && <img src={api.mediaUrl(sel.cover)} alt="" style={{ width: "100%", height: 180, objectFit: "cover", borderRadius: 20, display: "block", marginBottom: 14 }} />}
        <h2 style={{ margin: "4px 0 12px", fontSize: 21, fontWeight: 800, letterSpacing: -0.4, lineHeight: 1.25 }}>{sel.title}</h2>
        <div data-testid="info-content" style={{ color: C.ink }}>
          {paras.map((p, i) => <p key={i} style={{ margin: "0 0 12px", fontSize: 15, lineHeight: 1.75, whiteSpace: "pre-wrap" }}>{p}</p>)}
        </div>
        {Array.isArray(sel.images) && sel.images.length > 0 && (
          <div data-testid="info-gallery" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
            {sel.images.map((src, i) => <img key={i} src={api.mediaUrl(src)} alt="" style={{ width: "100%", height: 130, objectFit: "cover", borderRadius: 14 }} />)}
          </div>
        )}
      </Sheet>
    );
  }
  return (
    <Sheet testid="info-sheet" title="Info Jawsel" sub="Panduan, aturan, dan kontak" icon={Info} onClose={onClose}>
      {pages === null && <p style={{ color: C.sub, fontSize: 13, padding: "8px 2px" }}>Memuat...</p>}
      {pages && pages.length === 0 && <Empty icon={Info} testid="info-empty" text="Belum ada halaman info." />}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        {(pages || []).map(p => {
          const Icon = ikonUntuk(p.title);
          return (
            <button key={p.id} data-testid={`info-${p.id}`} onClick={() => setSel(p)}
              style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 10, textAlign: "left", border: 0, padding: 14, background: C.cream, borderRadius: 20, cursor: "pointer", color: C.ink, fontFamily: "inherit", minHeight: 128 }}>
              {p.cover
                ? <img src={api.mediaUrl(p.cover)} alt="" style={{ width: "100%", height: 64, objectFit: "cover", borderRadius: 12 }} />
                : <span style={{ width: 40, height: 40, borderRadius: 13, background: "#fff", display: "grid", placeItems: "center" }}><Icon size={18} color={C.blue} /></span>}
              <span style={{ flex: 1, minWidth: 0, width: "100%" }}>
                <b style={{ display: "block", fontSize: 14, lineHeight: 1.3, letterSpacing: -0.2 }}>{p.title}</b>
                <span style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", fontSize: 11.5, color: C.sub, lineHeight: 1.45, marginTop: 4 }}>{(p.content || "").replace(/\n+/g, " ")}</span>
              </span>
              <span style={{ display: "inline-flex", alignItems: "center", gap: 3, fontSize: 11.5, fontWeight: 700, color: C.blue }}>Baca <ChevronRight size={13} /></span>
            </button>
          );
        })}
      </div>
      {pages && pages.length > 0 && !pages.some(p => p.cover) && (
        <p style={{ margin: "14px 2px 0", display: "flex", alignItems: "center", gap: 6, fontSize: 11.5, color: C.sub }}><ImageIcon size={13} /> Gambar sampul halaman akan tampil di sini saat diunggah admin.</p>
      )}
    </Sheet>
  );
}
